import { gql } from 'apollo-boost';

export enum User {
  UpdateUser = 'updateuser',
  GetUserRoles = 'getUserroles',
  UpdateUserPassword = 'updateUserpassword',
  iGetUserByCompanyId = 'getuserbyCompanyid',
  shareAccess = 'shareAccess',
  AddUser = 'addUser',
  GetUserById = 'getuserbyid',
  GetUserByPassToken = 'getuserbypasstoken',
  ResendInvite = 'resendinvite',
  RevokeInvite = 'revokeinvite',
  DeleteUserRole = 'deleteUserrole',
  GetSharedAccess = 'getsharedsccess',
  ShareAccess = 'shareAccess',
  GetItemUsers = 'getItemUsers',
}

export const updateUserMutation = gql`
    mutation ${User.UpdateUser}(
        $firstName: String,
        $lastName: String,
        $email: String,
        $password: String,
        $profile_pic: String,
        $companyId: String,
        $roleId: String,
        $id: String!,
        $invitedStatus: String!
      ){
        ${User.UpdateUser}(
          firstName: $firstName
          lastName: $lastName
          email: $email
          password: $password
          profile_pic: $profile_pic
          companyId: $companyId
          roleId: $roleId
          id: $id
          invitedStatus: $invitedStatus
          ){
            message
            statusCode
        }
    }
`;

export const getRolesQuery = gql`
    query ${User.GetUserRoles}($userId: String!){
      ${User.GetUserRoles}(userId:$userId ){
        statusCode
        message
        data {
          id
          role_name
          created_at
          updated_at
        }
      }
    }
`;

export const updateUserPasswordMutation = gql`
    mutation ${User.UpdateUserPassword}(
      $id: String!
      $password: String!
      $oldpassword: String!
      ){
        ${User.UpdateUserPassword}(
          id: $id
          password: $password
          oldpassword: $oldpassword
          ){
            message
            statusCode
            data {
              updated
            }
        }
    }
`;

export const getUserByCompanyIdQuery = gql`
    query ${User.iGetUserByCompanyId}($company: String!){
      ${User.iGetUserByCompanyId}(company: $company) {
        statusCode
        message
        data {
          id
          first_name
          last_name
          email
          password
          profile_pic
          invitedStatus
          companyUserId
          lastActiveTime
          permissionType
          role {
            id
            role_name
          }
          settings {
            id
            isDarkMode
            twoFA
            authQR
          }
          emailSentTime
        }
      }
    }
  `;

export const addTeamMemberMutation = gql`
  mutation ${User.AddUser}(
      $email: [String]!
      $companyId: String
      $roleId: Int!
  ){
    ${User.AddUser}(
      email: $email
      companyId: $companyId
      roleId: $roleId
    ){
      statusCode
      message
    }
  }
`;

export const getUserByIdQuery = gql`
query ${User.GetUserById}($userId: String!){
  ${User.GetUserById}(userId: $userId) {
    statusCode
    message
    data {
      id
      first_name
      last_name
      email
      password
      profile_pic
      company {
        created_at
        id
      }
      role {
        id
      }
    }
  }
}
`;

export const getUserByPassTokenQuery = gql`
query ${User.GetUserByPassToken}($password_token: String!){
  ${User.GetUserByPassToken}(password_token: $password_token) {
    statusCode
    message
    data {
      id
      first_name
      last_name
      email
      password
      profile_pic
      isRegestered
      role {
        id
      }
      company {
        created_at
        id
        name
        email
        address
        city
        postal_code
        org_no
        phone_number
        country_code
        lastActiveTime
      }
    }
  }
}
`;

export const resendInviteMutation = gql`
  mutation ${User.ResendInvite}(
    $id:String!
  ){
    ${User.ResendInvite}(
      id: $id
    ){
      statusCode
      message
      data {
        sentInvite
      }
    }
  }
`;

export const revokeInviteMutation = gql`
  mutation ${User.RevokeInvite}(
    $id:String!
  ){
    ${User.RevokeInvite}(
      id: $id
    ){
      statusCode
      message
      data {
        revoked
      }
    }
  }
`;

export const deleteuserMutation = gql`
  mutation deleteuser($id: String!) {
    deleteuser(id: $id) {
      statusCode
      message
      data {
        isDeleted
      }
    }
  }
`;

export const deleteuserRoleMutation = gql`
  mutation ${User.DeleteUserRole}($id: String!) {
    ${User.DeleteUserRole}(id: $id) {
      statusCode
      message
      data {
				role_name
      }
    }
  }
`;

// export const shareAccessQuery = gql`
// query ${User.GetSharedAccess}($itemType: FOLDER, $folderType:SCREENZ, $  itemId: "3ec1e505-6b31-448f-a69f-ffaff4fd890d", users: [
//   { id: "25b6e5ea-a287-486a-b5f4-ba0088c152e0", accessType: EDIT }
//   { id: "41ba4245-e22c-4e09-93f9-d1ee4a46fd55", accessType: EDIT }
// ] ){
//   ${User.GetSharedAccess}(itemType: $itemType ) {
//     statusCode
//     message
//     statusCode
//     data {
//       shared
//       }
//     }
//   }
// }
// `;

export const shareAccessQuery = gql`
mutation ${User.ShareAccess}($itemType: ItemType!, $folderType: FolderType, $itemId: String! $users: [ShareUsers]!){
      ${User.ShareAccess}(itemType:$itemType, folderType: $folderType, itemId: $itemId, users: $users){
        statusCode
        message
        data {
          shared
        }
      }
    }
`;

export const getItemUsersQuery = gql`
    query ${User.GetItemUsers}(
      $itemType: ItemType!
      $folderType: FolderType
      $itemId: String!
      $companyId: String!
    ){
      ${User.GetItemUsers}(
        itemType: $itemType
        folderType: $folderType
        itemId: $itemId
        companyId: $companyId
      ){
        statusCode
        message
        data {
          id
          first_name
          last_name
          email
          password
          profile_pic
          invitedStatus
          companyUserId
          isRegestered
          lastActiveTime
          emailSentTime
        }
      }
    }
`;
